export const DIAS = ["Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"];
const HORA_INI = 7;
const HORA_FIN = 18;
const PASO = 15;
const FILAS = ((HORA_FIN - HORA_INI) * 60) / PASO;

const aMin = (h) => {
  const [a, b] = String(h).split(":").map(Number);
  return a * 60 + b;
};
const fila = (h) => Math.min(FILAS + 2, Math.max(2, Math.round((aMin(h) - HORA_INI * 60) / PASO) + 2));
export const horaDeFila = (i) => {
  const total = HORA_INI * 60 + i * PASO;
  return `${String(Math.floor(total / 60)).padStart(2, "0")}:${String(total % 60).padStart(2, "0")}`;
};
export const sumarMinutos = (h, min) => {
  const total = aMin(h) + min;
  return `${String(Math.floor(total / 60)).padStart(2, "0")}:${String(total % 60).padStart(2, "0")}`;
};

const COLORES = [
  "border-primary/50 bg-primary/10 text-primary",
  "border-amber-500/50 bg-amber-500/10 text-amber-700",
  "border-emerald-500/50 bg-emerald-500/10 text-emerald-700",
  "border-sky-500/50 bg-sky-500/10 text-sky-700",
  "border-fuchsia-500/50 bg-fuchsia-500/10 text-fuchsia-700",
  "border-rose-500/50 bg-rose-500/10 text-rose-700",
];
export const colorDe = (clave = "") =>
  COLORES[[...String(clave)].reduce((a, c) => a + c.charCodeAt(0), 0) % COLORES.length];

const conPosicion = (bloques) => {
  const salida = [];
  const porDia = {};
  bloques.forEach((b) => { (porDia[b.dia] = porDia[b.dia] || []).push(b); });
  Object.values(porDia).forEach((lista) => {
    const grupos = [];
    [...lista].sort((a, b) => aMin(a.hora_inicio) - aMin(b.hora_inicio)).forEach((b) => {
      const grupo = grupos.find((g) => g.some((x) =>
        aMin(x.hora_inicio) < aMin(b.hora_fin) && aMin(b.hora_inicio) < aMin(x.hora_fin)));
      if (grupo) grupo.push(b); else grupos.push([b]);
    });
    grupos.forEach((g) => g.forEach((b, i) => salida.push({ ...b, columna: i, columnas: g.length })));
  });
  return salida;
};

export const HorarioSemanal = ({ bloques = [], dias = 5, onSlot, onBloque, diaResaltado = -1 }) => (
  <div className="overflow-x-auto rounded-lg border border-border/60 bg-card">
    <div className="min-w-[720px] p-2">
      <div className="grid"
           style={{ gridTemplateColumns: `56px repeat(${dias}, minmax(120px, 1fr))`,
                    gridTemplateRows: `34px repeat(${FILAS}, 16px)` }}>
        <div style={{ gridColumn: 1, gridRow: 1 }} />
        {DIAS.slice(0, dias).map((d, i) => (
          <div key={d} style={{ gridColumn: i + 2, gridRow: 1 }}
               className={`flex items-center justify-center rounded-t-md text-xs font-bold uppercase tracking-[0.14em] ${
                 i === diaResaltado ? "bg-primary text-primary-foreground" : "text-muted-foreground"}`}>
            {d}
          </div>
        ))}

        {Array.from({ length: HORA_FIN - HORA_INI + 1 }).map((_, i) => (
          <div key={i} style={{ gridColumn: 1, gridRow: `${2 + i * 4} / span 4` }}
               className="pr-2 pt-0.5 text-right font-mono text-[10px] text-muted-foreground">
            {`${String(HORA_INI + i).padStart(2, "0")}:00`}
          </div>
        ))}

        {DIAS.slice(0, dias).map((d, di) =>
          Array.from({ length: FILAS }).map((_, si) => (
            <button key={`${di}-${si}`} type="button" disabled={!onSlot}
                    onClick={() => onSlot?.(di, horaDeFila(si))}
                    data-testid={onSlot ? `slot-${di}-${horaDeFila(si)}` : undefined}
                    className={`border-l border-border/40 ${
                      si % 4 === 0 ? "border-t border-border/50" : si % 2 === 0 ? "border-t border-dashed border-border/30" : ""} ${
                      onSlot ? "cursor-pointer hover:bg-primary/5" : "cursor-default"}`}
                    style={{ gridColumn: di + 2, gridRow: si + 2 }} />
          )),
        )}

        {conPosicion(bloques.filter((b) => b.dia < dias)).map((b) => (
          <button key={b.id} type="button" disabled={!onBloque} onClick={() => onBloque?.(b)}
                  data-testid={`bloque-${b.id}`}
                  style={{ gridColumn: b.dia + 2,
                           gridRow: `${fila(b.hora_inicio)} / ${fila(b.hora_fin)}`, zIndex: 2,
                           width: `calc(${100 / b.columnas}% - 4px)`,
                           marginLeft: `calc(${(100 * b.columna) / b.columnas}% + 2px)` }}
                  className={`my-[2px] overflow-hidden rounded-md border px-2 py-0.5 text-left transition-transform ${
                    colorDe(b.materia_nombre)} ${onBloque ? "hover:scale-[1.02]" : ""}`}>
            <p className="truncate text-[11px] font-bold leading-tight" title={b.materia_nombre}>{b.materia_nombre}</p>
            <p className="truncate font-mono text-[10px] leading-tight opacity-80">{b.hora_inicio}–{b.hora_fin}</p>
            <p className="truncate text-[10px] leading-tight opacity-80" title={b.subtitulo}>{b.subtitulo}</p>
          </button>
        ))}
      </div>
    </div>
  </div>
);
